// extracted by mini-css-extract-plugin
export default {"root":"jZLM9q","limited-time-banner":"OxB3Fs","limitedTimeBanner":"OxB3Fs","accent":"oy2Y9m","pulsar":"eE0uh8","pulse-animation":"wxP56E","pulseAnimation":"wxP56E"};